import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { FaLinkedinIn, FaInstagram, FaFacebookF } from 'react-icons/fa';
import { MdOutlineMail, MdOutlineVerifiedUser } from 'react-icons/md';
import logo from 'assets/footer/logo-blanco.png';
import scrollToTop from 'utils/scrollToTop';
import css from './css.module.scss';

// Social links kept from the previous footer.
const socials = (language) => [
  { label: 'LinkedIn', href: language === 'pt' ? 'https://www.linkedin.com/company/smile-brasil' : 'https://www.linkedin.com/company/smile-latam/', icon: FaLinkedinIn },
  { label: 'Instagram', href: 'https://www.instagram.com/smile.latam/', icon: FaInstagram },
  { label: 'Facebook', href: 'https://www.facebook.com/Smile.Latam/', icon: FaFacebookF },
  { label: 'Email', href: 'mailto:info@smileweb.net', icon: MdOutlineMail },
];

const FooterView = ({
  t, language, columns, legal, advertisingView,
}) => (
  <footer className={css.footer}>
    <div className={css.inner}>
      <div className={css.top}>
        <div className={css.brand}>
          <Link to={advertisingView ? '#' : `/${language}/`} onClick={scrollToTop} className={css.logoLink}>
            <img src={logo} alt="Smile" className={css.logo} />
          </Link>
          <p className={css.tagline}>{t('footerV2.tagline')}</p>
          <div className={css.socials} aria-label={t('footerV2.follow')}>
            {socials(language).map(({ label, href, icon: Icon }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className={css.social}>
                <Icon />
              </a>
            ))}
          </div>
        </div>

        {/* the advertising landings keep a minimal footer */}
        {!advertisingView && (
          <nav className={css.columns}>
            {columns.map((column) => (
              <div key={column.title} className={css.column}>
                <span className={css.columnTitle}>{column.title}</span>
                {column.links.map((link) => (
                  <HashLink key={link.label} smooth to={link.path} className={css.link}>
                    {link.label}
                  </HashLink>
                ))}
              </div>
            ))}
          </nav>
        )}
      </div>

      <div className={css.bottom}>
        <span>{`© ${new Date().getFullYear()} Smile · smilecx.io`}</span>
        <span className={css.legal}>
          <span className={css.iso}>
            <MdOutlineVerifiedUser />
            {t('footerV2.iso')}
          </span>
          {legal.map((item) => (
            <Link key={item.label} to={item.path} className={css.legalLink}>{item.label}</Link>
          ))}
        </span>
      </div>
    </div>
  </footer>
);

FooterView.propTypes = {
  t: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  legal: PropTypes.array.isRequired,
  advertisingView: PropTypes.bool.isRequired,
};

export default FooterView;
